<template>
	<header class="absolute inset-x-0 top-0 z-50">
		<nav class="flex items-center justify-between p-6 lg:px-8" aria-label="Global">
			<div class="flex lg:flex-1">
				<a href="#" class="-m-1.5 p-1.5">
					<span class="sr-only">Haldex</span>
					<img class="h-10 w-auto"
					     src="/images/logos/haldex.png" alt=""/>
				</a>
			</div>
			<div class="flex lg:hidden">
				<button type="button" class="-m-2.5 inline-flex items-center justify-center rounded-md p-2.5 text-primary-100"
				        @click="mobileMenuOpen = true">
					<span class="sr-only">Open main menu</span>
					<IconMenu2 class="h-6 w-6" aria-hidden="true"/>
				</button>
			</div>
			<div class="hidden lg:flex lg:gap-x-12">
				<a v-for="item in navigation" :key="item.name" :href="item.href" :target="item.target ?? '_self'"
				   class="text-sm font-semibold leading-6 text-primary-100">{{ item.name }}</a>
			</div>
			<div class="hidden lg:flex lg:flex-1 lg:justify-end">
				<router-link :to="{ name: 'login' }" class="text-sm font-semibold leading-6 text-primary-100">Log in <span
						aria-hidden="true">&rarr;</span></router-link>
			</div>
		</nav>
		<Dialog as="div" class="lg:hidden" @close="mobileMenuOpen = false" :open="mobileMenuOpen">
			<div class="fixed inset-0 z-50"/>
			<DialogPanel
					class="fixed inset-y-0 right-0 z-50 w-full overflow-y-auto bg-white px-6 py-6 sm:max-w-sm sm:ring-1 sm:ring-gray-900/10">
				<div class="flex items-center justify-between">
					<a href="#" class="-m-1.5 p-1.5">
						<span class="sr-only">Haldex</span>
						<img class="h-8 w-auto" src="https://tailwindui.com/img/logos/mark.svg?color=blue&shade=600" alt=""/>
					</a>
					<button type="button" class="-m-2.5 rounded-md p-2.5 text-gray-700" @click="mobileMenuOpen = false">
						<span class="sr-only">Close menu</span>
						<IconX class="h-6 w-6" aria-hidden="true"/>
					</button>
				</div>
				<div class="mt-6 flow-root">
					<div class="-my-6 divide-y divide-gray-500/10">
						<div class="space-y-2 py-6">
							<a v-for="item in navigation" :key="item.name" :href="item.href" :target="item.target ?? '_self'"
							   class="-mx-3 block rounded-lg px-3 py-2 text-base font-semibold leading-7 text-gray-900 hover:bg-surface-50">{{
									item.name
								}}</a>
						</div>
						<div class="py-6">
							<a href="#"
							   class="-mx-3 block rounded-lg px-3 py-2.5 text-base font-semibold leading-7 text-gray-900 hover:bg-surface-50">Log
								in</a>
						</div>
					</div>
				</div>
			</DialogPanel>
		</Dialog>
	</header>

	<div class="relative isolate px-6 pt-14 lg:px-8 bg-white">
		<div class="absolute inset-0 -z-10 bg w-full h-screen opacity-100"></div>
		<div class="mx-auto max-w-4xl py-32 sm:py-36 lg:py-36">

			<div class="text-center">
				<h1 class="text-4xl font-bold tracking-tight text-primary-100 sm:text-6xl">
					<span class="text-primary-500">SUMS:</span>
					Software Update Management System
				</h1>
				<p class="mt-6 text-lg leading-8 text-primary-300">Your Software Update Management System (SUMS) is what makes your
					cybersecurity activities effective: because software updates are the remedy to counter threats from
					cyberspace. With SUMS, you can handle these updates in compliance with regulatory requirements.</p>
				<div class="mt-10 flex items-center justify-center gap-x-6">
					<router-link :to="{name: 'login'}"
					             class="rounded-md bg-surface-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-surface-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600">
						Get started
					</router-link>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { Dialog, DialogPanel } from '@headlessui/vue'
import { IconMenu2, IconX } from '@tabler/icons-vue';

export default {
	name: "HeroSection",
	components: {
		Dialog,
		DialogPanel,
		IconMenu2,
		IconX,
	},
	data() {
		return {
			mobileMenuOpen: false,
			navigation: [
        {name: 'Haldex', href: import.meta.env.VITE_HALDEX_URL, target: '_blank'},
        {name: 'Support', href: import.meta.env.VITE_CUSTOMER_SUPPORT_URL, target: '_blank'},
        {name: 'User Guide', href: import.meta.env.VITE_USER_GUIDE_URL, target: '_blank'},
			]
		}
	},
}
</script>

<style scoped>
.bg {
	background-color: #172554;
	background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='200' height='200' viewBox='0 0 800 800'%3E%3Cg fill='none' stroke='%231E3A8A' stroke-width='1'%3E%3Cpath d='M769 229L1037 260.9M927 880L731 737 520 660 309 538 40 599 295 764 126.5 879.5 40 599-197 493 102 382-31 229 126.5 79.5-69-63'/%3E%3Cpath d='M-31 229L237 261 390 382 603 493 308.5 537.5 101.5 381.5M370 905L295 764'/%3E%3Cpath d='M520 660L578 842 731 737 840 599 603 493 520 660 295 764 309 538 390 382 539 269 769 229 577.5 41.5 370 105 295 -36 126.5 79.5 237 261 102 382 40 599 -69 737 127 880'/%3E%3Cpath d='M520-140L578.5 42.5 731-63M603 493L539 269 237 261 370 105M902 382L539 269M390 382L102 382'/%3E%3Cpath d='M-222 42L126.5 79.5 370 105 539 269 577.5 41.5 927 80 769 229 902 382 603 493 731 737M295-36L577.5 41.5M578 842L295 764M40-201L127 80M102 382L-261 269'/%3E%3C/g%3E%3Cg fill='%231E3A8A'%3E%3Ccircle cx='769' cy='229' r='5'/%3E%3Ccircle cx='539' cy='269' r='5'/%3E%3Ccircle cx='603' cy='493' r='5'/%3E%3Ccircle cx='731' cy='737' r='5'/%3E%3Ccircle cx='520' cy='660' r='5'/%3E%3Ccircle cx='309' cy='538' r='5'/%3E%3Ccircle cx='295' cy='764' r='5'/%3E%3Ccircle cx='40' cy='599' r='5'/%3E%3Ccircle cx='102' cy='382' r='5'/%3E%3Ccircle cx='127' cy='80' r='5'/%3E%3Ccircle cx='370' cy='105' r='5'/%3E%3Ccircle cx='578' cy='42' r='5'/%3E%3Ccircle cx='237' cy='261' r='5'/%3E%3Ccircle cx='390' cy='382' r='5'/%3E%3C/g%3E%3C/svg%3E");
}
</style>